export const enum FormatAcceptHeaders {
  XLSX = 'application/vnd.ms-excel',
  CSV = 'text/csv',
  JSON = 'application/json',
}
